export default "__VITE_ASSET__CkgYNI5v__"